import { isCivilDate, romeDate } from "./businessValidation";

// A missing value is not zero: show a dash, keep real zeros.
const missing = (n) => n == null || n === "" || !Number.isFinite(Number(n));

export const fmtEUR = (n) =>
  missing(n) ? "—" : new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n));

export const fmtNum = (n) => missing(n) ? "—" : new Intl.NumberFormat("it-IT").format(Number(n));

function parsedDate(value) {
  if (typeof value === "string" && !isCivilDate(value.trim().slice(0, 10))) return null;
  if (!(value instanceof Date) && typeof value !== "string" && typeof value !== "number") return null;
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? date : null;
}

function formatDate(value, withTime) {
  if (value == null || value === "") return "—";
  const date = parsedDate(value);
  if (!date) return "Data non valida";
  return new Intl.DateTimeFormat("it-IT", {
    day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Europe/Rome",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  }).format(date);
}

export const fmtDate = (value) => formatDate(value, false);

export const fmtDateTime = (value) => formatDate(value, true);

// "YYYY-MM" → short Italian month, with no time zone shift.
export function fmtMonthShort(month) {
  const [year, number] = String(month || "").split("-").map(Number);
  if (!Number.isInteger(year) || !(number >= 1 && number <= 12)) return "—";
  return new Intl.DateTimeFormat("it-IT", { month: "short", timeZone: "UTC" }).format(new Date(Date.UTC(year, number - 1, 1)));
}

// `cls` is the tone class of the status pill (see .tone-* in index.css).
export const VEHICLE_STATUS = {
  disponibile: { label: "Disponibile", cls: "tone-green" },
  prenotato: { label: "Prenotato", cls: "tone-sky" },
  assegnato: { label: "Assegnato", cls: "tone-indigo" },
  in_consegna: { label: "In consegna", cls: "tone-cyan" },
  in_manutenzione: { label: "In manutenzione", cls: "tone-amber" },
  non_operativo: { label: "Non operativo", cls: "tone-red" },
  da_vendere: { label: "Da vendere", cls: "tone-orange" },
  venduto: { label: "Venduto", cls: "tone-slate" },
};

export const GENERIC_STATUS = {
  // maintenance
  pianificato: { label: "Pianificato", cls: "tone-sky" },
  da_autorizzare: { label: "Da autorizzare", cls: "tone-amber" },
  autorizzato: { label: "Autorizzato", cls: "tone-indigo" },
  in_lavorazione: { label: "In lavorazione", cls: "tone-cyan" },
  completato: { label: "Completato", cls: "tone-green" },
  annullato: { label: "Annullato", cls: "tone-slate" },
  // assignment
  pianificata: { label: "Pianificata", cls: "tone-sky" },
  in_corso: { label: "In corso", cls: "tone-indigo" },
  conclusa: { label: "Conclusa", cls: "tone-green" },
  // damage / fine
  aperto: { label: "Aperto", cls: "tone-red" },
  in_gestione: { label: "In gestione", cls: "tone-amber" },
  chiuso: { label: "Chiuso", cls: "tone-green" },
  da_pagare: { label: "Da pagare", cls: "tone-red" },
  pagata: { label: "Pagata", cls: "tone-green" },
  contestata: { label: "Contestata", cls: "tone-amber" },
};

export function deadlineSeverity(expiry, now = new Date()) {
  if (!expiry) return { sev: "valido", days: 9999, cls: "tone-green", label: "Valido" };
  const date = parsedDate(expiry);
  const current = parsedDate(now);
  if (!date || !current) return { sev: "non_valido", days: 9999, cls: "tone-slate", label: "Data non valida" };
  const expiryDay = isCivilDate(expiry) ? expiry : romeDate(date);
  const today = romeDate(current);
  const days = Math.round((Date.parse(`${expiryDay}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) / (1000 * 60 * 60 * 24));
  if (days < 0) return { sev: "scaduto", days, cls: "tone-red", label: "Scaduto" };
  if (days <= 15) return { sev: "in_scadenza", days, cls: "tone-amber", label: "In scadenza" };
  return { sev: "valido", days, cls: "tone-green", label: "Valido" };
}

export function labelize(s) {
  if (!s) return "—";
  return String(s).replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
}
